// Created by Weverton Couto
// on 23/10/2025
// for Techmatic Solutions
// using Odoo 17.0

import React from 'react';
import ChartistGraph from "react-chartist";

const GraficoBarrasTop5 = ({ dados }) => {
    if (!dados || dados.length === 0) {
        return (
            <div className="chart-card">
                <h3 className="chart-title">Top 5 Clínicas por Volume</h3>
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <i className="fas fa-chart-bar"></i>
                    </div>
                    <p className="empty-state-title">Nenhum dado disponível</p>
                    <p className="empty-state-text">Não há mensagens para exibir neste período</p>
                </div>
            </div>
        );
    }

    const chartData = {
        labels: dados.map(item => item.nome || item.idClinica),
        series: [dados.map(item => item.total)]
    };

    const chartOptions = {
        horizontalBars: true,
        axisX: {
            onlyInteger: true,
            showGrid: true,
            offset: 80
        },
        axisY: {
            showGrid: false,
            offset: 60
        },
        seriesBarDistance: 10
    };

    const chartType = 'Bar';

    return (
        <div className="chart-card">
            <h3 className="chart-title">Top 5 Clínicas por Volume</h3>
            <div className="chart-container">
                <ChartistGraph
                    data={chartData}
                    options={chartOptions}
                    type={chartType}
                />
            </div>
        </div>
    );
};

export default GraficoBarrasTop5;

